import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateIndeedFlexCompanyMutation } from 'queries/admin/indeedFlex/useCreateIndeedFlexCompanyMutation'

type CreateIndeedFlexCompanyFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateIndeedFlexCompanyMutation>['mutate']
    reset: ReturnType<typeof useCreateIndeedFlexCompanyMutation>['reset']
  }
}

const [Context, useCreateIndeedFlexCompanyFlowContextValue] =
  createContext<CreateIndeedFlexCompanyFlowContextState>({
    name: 'CreateIndeedFlexCompanyFlowContext',
  })

export const CreateIndeedFlexCompanyFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useCreateIndeedFlexCompanyMutation()

  const value: CreateIndeedFlexCompanyFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateIndeedFlexCompanyFlowContextValue }
